import React, {useEffect, useState} from 'react';
import Xarrow from "react-xarrows";

import {useFonts} from "../utils";

export const Line = (props) => {
  const {start, end, color, startAnchor = "right", endAnchor = "auto", classes, animateDrawing = false, showHead = false} = props;

  const [offset, setOffset] = useState(0);

  const fontsLoaded = useFonts('Rootstock Sans');

  useEffect(() => {
    if(fontsLoaded){
      setOffset(start.current.offsetHeight / 2)
    }

    const handleWindowResize = () => {
      if (!start.current) return;
      setOffset(start.current.offsetHeight / 2)
    }
    window.addEventListener("resize", handleWindowResize);

    // Return a function from the effect that removes the event listener
    return () => window.removeEventListener("resize", handleWindowResize);
  }, [start, fontsLoaded]);

  if (!start || !end) return;

  return (

    <Xarrow
      headShape='circle'
      start={start} //must be react ref
      end={end} //must be react ref
      showHead={showHead}
      color={color || "rgb(222,255,26)"}
      curveness={0}
      strokeWidth={1}
      animateDrawing={animateDrawing}
      startAnchor={{position: startAnchor, offset: {y: offset}}}
      endAnchor={endAnchor}
      passProps={{className: classes}}
    />
  )
}
